module.exports = __webpack_public_path__ + "media/2-8.6cb73ffc.wav";